/* global theme */

import { fetchConfig } from './global';

import jQuery from 'jquery';
import moment from 'moment';
import BsubWidget from '../js/bsubwidget.js';

String.prototype.interpolate = function(params) {
  const names = Object.keys(params);
  const vals = Object.values(params);
  return new Function(...names, `return \`${this}\`;`)(...vals);
}

class SubscriptionModifier extends BsubWidget {
    constructor () {
        
        super();

        this.subscription = {};

        this.attrs.productList = 'data-modifier-product-options';
        this.attrs.productOptions = 'data-modifier-product-option';
        this.attrs.subscriptionOptions = 'data-modifier-subscription-options';
        this.attrs.subscriptionModifier = 'data-jic-subscription-modifier';
        this.attrs.subscriptionStartDate = 'data-jic-subscription-startdate';

        this.templates = {
            product: 'tmpl-product',
            productAfter: 'tmpl-product-after',
            subscriptionOption: 'tmpl-subscription-option',
            startDate: 'tmpl-subscription-startdate'
        }

        // autogenerate selectors from attributes
        Object.entries(this.attrs).forEach(function ([key, value]) {
            this.selectors[key] = `[${value}]`;
        }.bind(this));
    }
    init () {
        
        console.debug('BSUBMODIFIER: Initializing widgets...');
        if (!document.querySelector(this.selectors.subscriptionModifier)) {
            console.debug('BSUBMODIFIER: No widgets detected, skipping initialization.');
            return;
        }

        this.subscriptionModifier = document.querySelector(this.selectors.subscriptionModifier);

        var _this = this;

        window.BOLD.subscriptions.getJWT(function(data){
            _this._handleJWTResponse(data);
        });
        
    }

    _continueInit(){

        let shopDomain = window.BOLD.subscriptions.config.shopDomain;
        let shopPlatform = window.BOLD.subscriptions.config.platform;
        let _this = this;

        jQuery.get( `https://sub.boldapps.net/api/customer/login?platform_customer_id=${this.subscription.customer_id}&customer_jwt=${this.subscription.jwt}&shop=${shopDomain}&platform_type=${shopPlatform}`, function( data ) {
          _this.subscription.customer = data.customer;
          _this.subscription.webToken = data.subscriptionsWebToken;
          _this.subscription.WebTokenExpiry = data.subscriptionsWebTokenExpTime
        }).then(() => {

            setInterval(function(){
                _this._refreshToken()
            }, 60000);

            const params = new Proxy(new URLSearchParams(window.location.search), {
              get: (searchParams, prop) => searchParams.get(prop),
            });

            if(params.id){

                _this._getSubscription(params.id).then((data) => {

                    _this.subscriptionData = data.subscription

                    console.log(_this.subscriptionData);

                    _this.subscriptionModifier.dataset.subscriptionGroup = _this.subscriptionData.line_items[0].subscription_group_id;
                    _this.subscriptionModifier.dataset.builderProductOptions = '';

                    _this._initProducts();

                });
                
            }

        });

    }

    _api(url, method = 'GET', data = {}){

        let shopDomain = window.BOLD.subscriptions.config.shopDomain;
        let shopPlatform = window.BOLD.subscriptions.config.platform;

        let _this = this;
        let webToken = _this.subscription.webToken;

        return jQuery.ajax({
            method: method,
            url: `${url}?shop=${shopDomain}&platform_type=${shopPlatform}`,
            data: data,
            beforeSend: function (xhr) {
                xhr.setRequestHeader("Authorization", `Bearer ${webToken}`);
            }
        });

    }

    _getSubscription(subscription){

        return this._api(`https://sub.boldapps.net/api/customer/subscriptions/${subscription}`);

    }

    _refreshToken(){

        let shopDomain = window.BOLD.subscriptions.config.shopDomain;
        let shopPlatform = window.BOLD.subscriptions.config.platform;
        let _this = this;
        let webToken = _this.subscription.webToken;

        console.log('refreshing token')

        jQuery.ajax({
            url: `https://sub.boldapps.net/api/customer/jwt/refresh?shop=${shopDomain}&platform_type=${shopPlatform}`,
            beforeSend: function (xhr) {
              xhr.setRequestHeader("Authorization", `Bearer ${webToken}`);
            },
            success: function( data ) {
                _this.subscription.webToken = data.token;
                _this.subscription.WebTokenExpiry = data.tokenExpTime;
            }
        });

    }

    _handleJWTResponse(data){

        console.log('handle JWT');

        if(data.success == true){
            this.subscription.jwt = data.value.jwt;
            this.subscription.customer_id = data.value.customerId;
            this._continueInit();
        }else{
            jQuery('.jic-subscription-modifier').parents('.container').html('<div id="customer-portal-root"><div class="bsub-auth-message__flex"><span>This is awkward. You need to log in.</span></div></div>');
            return false;
        }

    }

    _initProducts () {

        var _this = this;
        var productTemplate = document.getElementById(this.templates.product) ? document.getElementById(this.templates.product).innerHTML : false;
        var productAfterTemplate = document.getElementById(this.templates.productAfter) ? document.getElementById(this.templates.productAfter).innerHTML : false;
        var subscriptionOptionTemplate = document.getElementById(this.templates.subscriptionOption) ? document.getElementById(this.templates.subscriptionOption).innerHTML : false;
        var startDateTemplate = document.getElementById(this.templates.startDate) ? document.getElementById(this.templates.startDate).innerHTML : false;

        var subscriptionStartDate = document.querySelector(_this.selectors.subscriptionStartDate);
        var allProductsData = document.querySelectorAll(_this.selectors.productJson);

        var allProducts = [];

        allProductsData.forEach(function(allProductData){
            var json = JSON.parse(allProductData.innerHTML);
            json.meta = {};
            if(allProductData.hasAttribute('data-bsub-case-size')) json.meta.subscription_case_size = allProductData.getAttribute('data-bsub-case-size');
            if(allProductData.hasAttribute('data-bsub-subscription-image')) json.meta.subscription_image = allProductData.getAttribute('data-bsub-subscription-image');
            allProducts.push(json);
        });

        var allPlanOptions = {};

        if(allProducts.length > 0){

            var productLists = document.querySelectorAll(_this.selectors.productList);
            var subscriptionOptions = document.querySelectorAll(_this.selectors.subscriptionOptions);

            productLists.forEach(function (productList) {

                var productListGroupId = parseInt(productList.getAttribute('data-subscription-group'));
                var productListGroup = window.BOLD.subscriptions.getSubscriptionGroupById(parseInt(productListGroupId));
                var productListGroupProductIds = productListGroup.selection_options;

                var productListHtml = '';

                allProducts.forEach(function(product){

                    if(productListGroupProductIds.find(o => o.platform_entity_id == product.id) && product.selling_plan_groups.length > 0){

                        let quantity = _this.subscriptionData.line_items.filter(line_item => line_item.platform_product_id == product.id).reduce((accumulator, line_item) => accumulator + line_item.quantity, 0);

                        if(!quantity){ quantity = 0; }

                        productListHtml += productTemplate.interpolate({ product: product, group: productListGroup, quantity: quantity });

                        product.selling_plan_groups.forEach(function(sellingPlanGroup){

                            sellingPlanGroup.selling_plans.forEach(function(sellingPlanGroupSellingPlan){

                                allPlanOptions[sellingPlanGroupSellingPlan.name] = sellingPlanGroupSellingPlan

                            })

                        });

                    }

                });
            
                if(productAfterTemplate) productListHtml += productAfterTemplate;

                productList.innerHTML = productListHtml;

                //subscriptionStartDate.innerHTML = startDateTemplate.interpolate({ startdate: moment(_this.subscriptionData.next_order_datetime).format('YYYY-MM-DD'), startdatemin: moment().add(1, 'days').format('YYYY-MM-DD'), startdatemax: moment().add(6, 'weeks').format('YYYY-MM-DD')})

                this._initProductList(productList);

                var productGroupBillingIds = productListGroup.billing_rules;

                var productBillingHtml = '';

                productGroupBillingIds.forEach(function(billingPlan){

                    if(allPlanOptions[billingPlan.interval_name]){

                        billingPlan.data = allPlanOptions[billingPlan.interval_name];

                        productBillingHtml += subscriptionOptionTemplate.interpolate({ plan: billingPlan });

                    }

                });

                subscriptionOptions[0].innerHTML = productBillingHtml;

                this._initOptionsAndSubmit(subscriptionOptions[0], productList);

            }.bind(_this));

        }

        // this._parsePageTemplate();
        // this._parseProductJson();
        // this._addVariantChangeListener();

        // var widgets = document.querySelectorAll(this.selectors.widget);
        // widgets.forEach(function (widget) {
        //     this._renderPrices(widget);
        //     this._renderGroupDiscountSummary(widget);
        // }.bind(this));

        // window.addEventListener("pageshow", function () {
        //     this.syncAllVisuallySelected();
        // }.bind(this));

        // console.debug('BSUBBUILDER: Successfully initialized widgets.');

    }

    _checkMinimums(){

        let totalproducts = 0;

        jQuery('.jic-subscription-builder').find('input[type="number"]').each(function () {
            totalproducts += parseInt(jQuery(this).val());
        });

        if (totalproducts > 1) {
            if (totalproducts > 7) {
                jQuery('.buying-for-business').show();
            } else {
                jQuery('.buying-for-business').hide();
            }

            jQuery('.subscription-action-buttons .open-how-often').prop( "disabled", false );

            if (jQuery('.woocommerce-Price-discount-amount').length > 0) {
                jQuery('.woocommerce-Price-amount').addClass('strike');
                jQuery('.woocommerce-Price-discount-amount').show();
            }

        } else {

            jQuery('.subscription-action-buttons .open-how-often').prop( "disabled", false );

            jQuery('.buying-for-business').hide();
            if (jQuery('.woocommerce-Price-discount-amount').length > 0) {
                jQuery('.woocommerce-Price-amount').removeClass('strike');
                jQuery('.woocommerce-Price-discount-amount').hide();
            }

        }

    }

    _initProductList () {

        let _this = this;

        _this._checkMinimums();

        jQuery('.number-input input[type="button"]').click(function () {

            var adjustment = jQuery(this).hasClass('button-plus') ? 1 : -1 ;

            const currentVal = parseInt(jQuery(this).parent().find('input[type="number"]').first()
                .val(), 10);

            if (!isNaN(currentVal)) {
                jQuery(this).parent().find('input[type="number"]').first()
                    .val(currentVal + adjustment)
                    .trigger('change');
            } else {
                jQuery(this).parent().find('input[type="number"]').first()
                    .val(0)
                    .trigger('change');
            }

            _this._checkMinimums();

        });

        jQuery('.open-how-often').click(function () {
            const minimum = jQuery(this).attr('data-minimum');
            const humanminimum = jQuery(this).attr('data-minimum-human');

            let totalproducts = 0;

            jQuery('.jic-subscription-builder').find('input[type="number"]').each(function () {
                totalproducts += parseInt(jQuery(this).val());
            });

            if (totalproducts < minimum) {
                if(jQuery('p.error').length < 1){
                    jQuery(`<p class='error text-right' style="margin-right: 1rem;">Please select at least ${humanminimum} product for your subscription.</p>`).insertBefore(jQuery(this));
                }
            } else {
                jQuery('p.error').remove();

                jQuery('.subscription-action-buttons').hide();
                jQuery('.jic-subscription-builder').slideUp();
                jQuery('.subscription-preferences').slideDown();

                jQuery('.subscription-preferences').find('.subscription-option:nth-child(2)').find('input').prop('checked', true);

                if(jQuery('.section-subscription-progress').length){
                    jQuery('.section-subscription-progress .step').removeClass('active');
                    jQuery('.section-subscription-progress .step-2').addClass('active');
                    jQuery('html, body').animate({ scrollTop: jQuery('.section-subscription-progress').offset().top }, 'slow');
                }
            }
        });

        jQuery('.open-bundle-section').click(function () {
            // e.preventDefault();

            jQuery('.subscription-action-buttons').show();
            jQuery('.jic-subscription-builder').slideDown();
            jQuery('.subscription-preferences').slideUp();

            if(jQuery('.section-subscription-progress').length){
                jQuery('.section-subscription-progress .step').removeClass('active');
                jQuery('.section-subscription-progress .step-1').addClass('active');
                jQuery('html, body').animate({ scrollTop: jQuery('.section-subscription-progress').offset().top }, 'slow');
            }
        
        });
        
    }

    _initOptionsAndSubmit () {

        var _this = this;
        var productOptions = document.querySelectorAll(_this.selectors.productOptions);
        var subscriptionOptions = document.querySelectorAll(_this.selectors.subscriptionOptions);

        jQuery('.submit-subscription').click(function(){

            jQuery(this).prop("disabled", true).addClass('running');

            var planSelection = jQuery(subscriptionOptions).first().find('input[type="radio"]:checked').val();

            let selectedInput = jQuery(subscriptionOptions).first().find('input[type="radio"]:checked');
            let inputLabel = selectedInput.next().find('span').text();

            var cartAdd = { items: [] };

            var totalQty = 0;

            productOptions.forEach(function(product){

                var input = jQuery(product).find('input[type="number"]');
                var inputId = input.attr('id');
                var inputQty = input.val();

                if(inputQty > 0) {

                    totalQty += inputQty;

                    console.log(_this.subscriptionData);

                    /* SKIO updates to grab SKIO selling plan */
                    var productId = jQuery(product).find('input[type="number"]').attr('productId');
                    let productJson = JSON.parse(document.querySelector(`[data-bsub-product-json][data-bsub-product-id="${ productId }"]`).innerHTML);
                    let selling_plan_groups = productJson?.selling_plan_groups?.filter(x => x.app_id == "SKIO");
                    let selling_plan_group = selling_plan_groups?.find(x => x.options[0].name.includes(inputId));
                    let selling_plan = selling_plan_group?.selling_plans?.find(x => x.name.includes(inputLabel.toLowerCase()));

                    cartAdd.items.push({
                        id: inputId,
                        quantity: inputQty,
                        selling_plan: selling_plan?.id,
                        properties: {
                            '_swap': _this.subscriptionData.bold_platform_subscription_id
                        }
                    })
                }

            });

            fetch('/cart.js', {
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(response => response.json())
            .then((cart) => {

                cart.items.forEach((item) => {

                    if(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name.includes(inputLabel.toLowerCase())){

                        fetch('/cart/change.js', {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json'
                          },
                          body: JSON.stringify({ id: item.key, quantity: 0, sections: "header,cart-items,cart-icon-bubble,cart-live-region-text,cart-footer" })
                        })

                    }

                })

            })
            .then(() => {

                cartAdd.sections = "header,cart-items,cart-icon-bubble,cart-live-region-text,cart-footer";

                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(cartAdd)
                })
                .then(() => {
                    if(totalQty > 1){
                        window.location.href = '/discount/15OFF?redirect=/checkout';
                    }else{
                        window.location.href = '/checkout';
                    }
                });

            })

        });

    }
}

export default SubscriptionModifier;